/* eslint camelcase: ["error", {allow: ["display_location", "nudge_id", "card_id", "card_title"]}] -- IPM wire tags. */
import {type IpmMetricTags, reportIpmAction, reportIpmDismiss} from '@github-ui/ipm-telemetry'

import type {PersonaTask} from '../data/persona-tasks'
import type {CopilotPersona} from '../data/personas'

const tags = {
  package: 'copilot-immersive-v1',
  surface: 'copilot',
  display_location: 'new_conversation',
  category: 'onboarding',
  nudge_id: 'copilot_persona_onboarding',
} satisfies IpmMetricTags
const options = {requestUrl: '/copilot', samplingProbability: 1}

export function reportPersonaOnboardingDismissed() {
  reportIpmDismiss({...tags, component: 'persona_onboarding_modal'}, options)
}

export function reportPersonaOnboardingCompleted(persona: CopilotPersona) {
  reportIpmAction('submit', {...tags, component: 'persona_onboarding_modal', persona}, options)
}

export function reportPersonaTaskSelected(persona: CopilotPersona, task: Pick<PersonaTask, 'id' | 'title'>) {
  reportIpmAction(
    'click',
    {...tags, component: 'persona_task_suggestions', persona, card_id: task.id, card_title: task.title},
    options,
  )
}

export function reportPersonaTasksDismissed(persona: CopilotPersona) {
  reportIpmDismiss({...tags, component: 'persona_task_suggestions', persona}, options)
}
